import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import MainPage from './components/pages/main-page/MainPage';
import PrivacyPolicy from './components/pages/privacy-policy/PrivacyPolicy';

import './App.scss';

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/privacy_policy" component={PrivacyPolicy} />
          <Route path="/" component={MainPage} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
